import { bool, func, number, shape, string } from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { approvalShape } from '../prop-types';
import api from '../REST/api';
import withApiRequest from '../REST/with-api-request';

function DeleteApprovalButton({
  opportunityId,
  onRequest,
  loading,
  approval,
  location,
  history,
}) {
  const { id } = approval;
  return (
    <Button
      color="danger"
      disabled={loading}
      onClick={() => {
        return onRequest(opportunityId, id).then(() => {
          const search = qs.parse(location.search);
          history.push({
            pathname: location.pathname,
            search: qs.stringify({ ...search, approval: 'close' }),
          });
        });
      }}
    >
      Delete
    </Button>
  );
}

DeleteApprovalButton.propTypes = {
  location: shape({ search: string }).isRequired,
  history: shape({ push: func.isRequired }).isRequired,
  opportunityId: number.isRequired,
  approval: approvalShape.isRequired,
  onRequest: func.isRequired,
  loading: bool.isRequired,
};

export default withApiRequest({
  query: api.deleteApproval,
  error: 'flash',
  successMessage: 'Approval deleted successfully',
})(withRouter(DeleteApprovalButton));
